//use constants everywhere. no typo, 1 source of update
export const pages = {
  login: 'login',
  home: 'home',
  supportInbox: 'supportinbox',
  dealers: 'dealers',
  settings: 'settings',
  franchiseeBridge: 'franchisee-bridge'
};
